'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _taskItem = require('./taskItem.html');

var _taskItem2 = _interopRequireDefault(_taskItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var taskItem = {
    bindings: {
        callingPageRefId: '@',
        callingPage: '@',
        task: '=',
        deleteTask: '&',
        tasksCount: '@?'
    },
    template: _taskItem2.default,
    controller: function controller($state) {
        var _this = this;

        this.displayFullName = function (task) {
            var name = '';
            var temp = _this.displayName(task);
            if (task.campaign && task.campaign.campaignTitle.length > 0) name = name + task.campaign.campaignTitle + ' | ';
            if (temp && temp.length > 0) name = name + temp + ' | ';
            if (task.investor && task.investor.investorName.length > 0) name = name + task.investor.investorName + ' | ';
            if (name.length > 0) return name.substring(0, name.length - 3);else return '';
        };

        this.displayName = function (task) {
            if (!task.contactExtension || !task.contactExtension.contactInfo || !task.contactExtension.contactInfo.contact) return '';
            var name = '';
            if (task.contactExtension.contactInfo.contact.salutation && task.contactExtension.contactInfo.contact.salutation.length > 0) name = name + task.contactExtension.contactInfo.contact.salutation + ' ';
            if (task.contactExtension.contactInfo.contact.firstName && task.contactExtension.contactInfo.contact.firstName.length > 0) name = name + task.contactExtension.contactInfo.contact.firstName + ' ';
            if (task.contactExtension.contactInfo.contact.lastName && task.contactExtension.contactInfo.contact.lastName.length > 0) name = name + task.contactExtension.contactInfo.contact.lastName + ' ';
            if (name.length > 0) return name.substring(0, name.length - 1);else return '';
        };

        this.getTaskUrl = function () {
            return $state.href('taskDetail', {
                taskId: _this.task.task.taskId,
                callingPage: _this.callingPage,
                referenceId: _this.callingPageRefId,
                tasksCount: _this.tasksCount
            });
        };
    }
};

exports.default = taskItem;


/** WEBPACK FOOTER **
 ** ./src/app/directives/taskList/taskItem.js
 **/